<template>
  <TabList :unstyled="true" :pt="passThrough" class="meridia-tab-list" v-bind="$attrs">
    <slot />
  </TabList>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import TabList from 'primevue/tablist';
import { usePassThrough } from 'primevue/passthrough';
import type { PassThrough } from '@primevue/core';
import type { TabListPassThroughOptions } from 'primevue/tablist';
import type { MeridiaTabListProps } from 'src/design_system/components/tab/types';

const props = defineProps<MeridiaTabListProps>();

const defaultPt: TabListPassThroughOptions = {
  root: {
    class: 'meridia-tab-list-root flex w-full h-12',
  },
  tabList: {
    class: 'meridia-tab-list-nav relative flex flex-1 gap-0 list-none m-0 p-0',
  },
  activeBar: {
    class: 'meridia-tab-list-active-bar absolute top-0 h-1 bg-primary transition-all duration-200',
  },
  content: {
    class: 'meridia-tab-list-content flex flex-1 overflow-x-auto overflow-y-hidden h-full',
  },
  prevButton: {
    class: 'meridia-tab-list-prev',
  },
  nextButton: {
    class: 'meridia-tab-list-next',
  },
};

const passThrough = computed(() =>
  usePassThrough(
    props.pt,
    defaultPt,
    { mergeSections: false, mergeProps: true }
  ) as PassThrough<TabListPassThroughOptions>
);
</script>
